import React, { useEffect } from "react";
import styled from "styled-components";
import back from '../../assets/back.svg';
import share from '../../assets/three_circle_share.svg';
import "react-spring-bottom-sheet/dist/style.css";

const Container = styled.div`
  height: 40px;
  padding: 16px 20px;
  display: flex;
  flex-direction: row;
  /* width: 100%; */
  justify-content: space-between;
  border-bottom: 2px solid #0E0F18;
  padding-bottom: 0px;
`;

const BackArrow = styled.img`
  height: 20px;
  margin-right: 20px;
`;

const Share = styled.img`
  height: 20px;
  /* margin-right: 20px; */
`;

const Title = styled.span`
    font-family: 'Poppins';
    font-style: normal;
    /* font-weight: 500; */
    font-size: 20px;
    line-height: 24px;
    color: #FFFFFF;
`;

export default function GlipHeader(props) {
  return (    
    <Container>
        <div>
          <BackArrow onClick={() => {           
            if(window.androidEmbeded) {
              window.backPressed();
              window.unSubscribeBackPress();
            } else {
              props.backPress()
            };
            window.analytics.track('backPressed', {
              item: 'glipheader',
            });         
          }} src={back}/>
          <Title>{props.title}</Title>
        </div>
        {!props.hideShare && <Share onClick={() => window.shareMessage(window.location.href)} src={share}/>}
    </Container>      
  );
}
